module.exports = {
  font: 'normal 12px sans-serif',
  fontAlign: 'start',
  fontBaseline: 'top',
  fontPos: [10,10]
};